<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 900px;">
            <dx-form [formData]="filter" [colCount]="3" validationGroup="mainValidationGroup">
                <dxi-item itemType="group">
                    <dxi-item dataField="startDate" editorType="dxDateBox" [disabled]="filter.type === 'Unapproved'"> </dxi-item>
                    <dxi-item dataField="endDate" editorType="dxDateBox"></dxi-item>
                </dxi-item>
                <dxi-item dataField="type" [label]="{ text: 'Filter By' }" editorType="dxSelectBox" [editorOptions]="{ items: options }"> </dxi-item>
            </dx-form>
            <div class="row mt-3">
                <div class="col-2 btn-toolbar">
                    <button type="button" (click)="switchWeeks()" class="btn btn-secondary" style="min-width: 130px;">
                        {{ !showingPreviousWeek ? 'Previous Week' : 'Current Week' }}
                    </button>
                </div>
                <div class="col-10 btn-toolbar justify-content-end">
                    <div  class="mt-1 mr-3">{{ itemCount }} {{ itemCount === 1 ? 'item found' : 'items found' }}</div>
                    <button type="button" (click)="search()" class="btn btn-success">Search</button>
                    <!-- <button type="button" (click)="clear()" class="btn btn-secondary ml-2">Clear</button> -->
                </div>
            </div>
        </div>
    </div>
    <div class="m-1 grid-fill" *ngIf="items">
        <dx-pivot-grid #pivotGrid
                       *ngIf="pivotDataSource"
                       [dataSource]="pivotDataSource"
                       [showBorders]="true"
                       [allowFiltering]="true"
                       [allowSortingBySummary]="true"
                       [allowSorting]="true"
                       [showColumnGrandTotals]="true"
                       [showColumnTotals]="true"
                       [showRowGrandTotals]="true"
                       [showRowTotals]="false"
                       [wordWrapEnabled]="false"
                       [rowHeaderLayout]="'tree'"
                       (onContextMenuPreparing)="contextMenuPreparing($event)"
                       (onCellClick)="onCellClick($event)"
                       (onCellPrepared)="onCellPrepared($event)">
            <dxo-field-panel [showDataFields]="true" [showRowFields]="true" [showColumnFields]="true" [showFilterFields]="true" [allowFieldDragging]="true" [visible]="true">
            </dxo-field-panel>
            <dxo-field-chooser [enabled]="true" [height]="600"></dxo-field-chooser>
            <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="timeReviewPivotGrid"> </dxo-state-storing>
            <dxo-export [enabled]="true"></dxo-export>
        </dx-pivot-grid>
    </div>
</div>
